import React from 'react';
import lightLogo from '../../../assets/img/hotel_tech_report_logo.jpeg';
import darkLogo from '../../../assets/img/hotel_tech_report_logo.jpeg';

export default function defaultLogo(theme) {
    if (theme === 'dark') {
        return <img src={darkLogo} alt="dark logo" className='placeholder-logo' />;
    }

    return <img src={lightLogo} alt="light logo" className='placeholder-logo' />;
}
